import apiClient from "../lib/apiClient";

export const getMCQReport = async (payload) => {

  try {

    const response = await apiClient.post(
      "/MCQ/GetReport",
      payload,
      { skipAuth: true }
    );

    return response.data;

  } catch (error) {

    console.log(
      "MCQ REPORT ERROR:",
      error
    );

    return null;

  }

};

//==================GetMcqReport==================
// ======================================
// GET MCQ RESULT
// ======================================

export const getMCQResult = async (summaryId, identity = {}) => {

  try {

    const response = await apiClient.post(
      "/MCQ/GetMcqResult",
      {
        SummaryId: summaryId,
        ...identity,
      },
      { skipAuth: true }
    );

    console.log(
      "MCQ RESULT API:",
      response.data
    );

    return response.data;

  } catch (error) {

    console.log(
      "API ERROR:",
      error
    );

    throw error;

  }

};

//=======================GetMcq by Test Id============
export const getTestByTestId = async (testId) => {
  try {

    const response = await apiClient.post(
      `/MCQ/GetTestByTestId`,
      {
        TestId: testId,
        ShowAnswer: "Y",
      }
    );

    return response.data;

  } catch (error) {

    console.error("GetTestByTestId Error:", error);

    throw error;
  }
};

// ======================================
// SAVE MCQ RESULT
// ======================================

export const saveMcqResult = async (payload) => {

  try {

    const response = await apiClient.post(
      "/MCQ/SaveMcqResult",
      payload
    );

    console.log(
      "SAVE MCQ RESULT:",
      response.data
    );

    return response.data;

  } catch (error) {

    console.log(
      "SAVE MCQ ERROR:",
      error
    );

    throw error;

  }

};
